
import React, { useState } from 'react';
import { Button, Input, message, Steps, theme } from 'antd';

import '../../build.css'
import Buildtable from '../Buildtable';



 const Sop2=() =>{
  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);
  const [inputValue, setInputValue] = useState(''); // State for the input value

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [  
    
    {
      title: 'Intro',
      content: <>
      <div   style={{marginTop:'2rem',}}>
      <Buildtable />
      <h6 id="profile">STATEMENT OF PURPOSE</h6>
      <p style={{ marginTop: "1rem" }}>
      In this scenario, where you are transitioning from a job in Electrical and Electronics Engineering (EEE) to pursuing a Master's in Computer Science and Engineering (CSE) with the background of CSE in UG, then "Why this Course" section becomes pivotal. This is the section where you can effectively convey how your diverse background and professional experience align with your decision to switch fields and pursue a master's degree in CSE.
                </p>


           
                 <p> <strong>Why this Course - Key Emphasis Section </strong> </p>
                <br></br>
                <h6>Introduction: </h6>
                <p>In the introduction, you want to grab the reader's attention by clearly stating the academic field you are passionate about. Rather than beginning with personal details, dive into the subject matter. Explain what aspects of this field interest you and why. This could include specific experiences, classes, or personal moments that sparked your interest. Convey your enthusiasm for the subject and provide a brief glimpse into what you hope to achieve within this domain.</p>
                <p>
                  <strong >Mistakes that need to be taken care of: </strong> 
                  <br></br>
                
                  <strong>Avoid Ambiguity:</strong> {" "} Clearly articulate why this field captures your interest. Vague statements may leave the reader unsure about your genuine passion.
                  <br></br><p> <strong>Steer Clear of Clichés: {" "}</strong> {" "} Be original in expressing your interest. Avoid clichés that might make your introduction sound generic.</p>
                </p>
                <br></br>
                


                <hr></hr>
              
       
        </div></>,
    },
    {
      title: 'background',
      content: <>
  <div className='martop'  > <p>
                  <strong>Background:-</strong> 
                  This section is an opportunity to showcase your academic and, if applicable, professional journey. Detail your academic achievements, focusing on relevant courses or projects that have prepared you for the desired program. If you have work experience, highlight how it has contributed to your skills and knowledge. In the case of extracurricular activities, emphasize those that demonstrate skills applicable to the academic and professional world.
                
                </p>
               <p><strong>Mistakes that need to be taken care of: </strong>
                </p>
              <p><strong>Irrelevant Details:</strong></p>
                <p>While providing your background, stay focused on elements that directly contribute to your suitability for the program. Avoid unnecessary details.</p>
                <h6> <strong>Overemphasis on Grades:</strong></h6>
                <p> While academic achievements are important, balance the discussion with other aspects of your background to present a holistic picture.</p>
               

     
                
                {/* <hr></hr> */}

                <hr></hr></div> </>,
    },
    {
        title: 'Course',
        content: <>  <div class="  martop" >
  
      <p><strong>Why this Course - Key Emphasis Section </strong></p>
<p><strong>What to Include: </strong></p>
<p><strong>Relevance of Your Background: </strong></p>
Acknowledge your background in EEE and highlight aspects of your work experience that are relevant to CSE. This could include problem-solving skills, analytical thinking, or exposure to certain technologies.
        <p> <strong>Bridge Between EEE and CSE :  </strong> 
Clearly articulate how your work in EEE serves as a bridge to your interest in CSE. Discuss any interdisciplinary projects or experiences that involved elements of both fields.
</p>
        <p><strong>Passion for CSE: </strong>
        Demonstrate a genuine passion for computer science. Discuss specific experiences, projects, or challenges that sparked your interest and motivated your decision to pursue further studies in CSE.
        </p>
<p><strong>Skills Gap and Enhancement:</strong>
Clearly articulate how your work in EEE serves as a bridge to your interest in CSE. Discuss any interdisciplinary projects or experiences that involved elements of both fields.
</p>

<p><strong>Alignment with Career Goals:  </strong>   Clearly state how the CSE program aligns with your career goals. Discuss the specific aspects of the curriculum, such as courses, specializations, or projects, that will contribute to your professional development in the tech industry.</p>
<p><strong>How to Pen It:  </strong></p>
<p>Begin by acknowledging your background in EEE and briefly discussing your professional journey in this field. Emphasize skills and experiences that are transferable to CSE.</p>
<p>Discuss any interdisciplinary experiences where you collaborated with computer scientists or utilized CSE concepts in your EEE role. This demonstrates your ability to integrate knowledge across disciplines.</p>
<p>Articulate the moment or realization that sparked your interest in computer science. This could be a project, a specific technology, or a challenge that ignited your passion for the field.  </p>
<p>Address the skills gap resulting from your transition and explain why the master's program in CSE at [University] is the ideal solution. Discuss specific courses or resources that will help bridge this gap.</p>
<p>Convey a clear vision of how the master's program aligns with your long-term career goals in CSE. Highlight any aspirations for research, innovation, or contributions to the tech industry.</p>


<p><strong>Example:  </strong></p>
<p>My journey in Electrical and Electronics Engineering has equipped me with a robust foundation in problem-solving and analytical thinking. However, my professional trajectory has led me to a pivotal realization—the interconnectedness of my work with computer science. In a project involving [specific project details], I witnessed the seamless integration of EEE and CSE concepts, sparking a profound interest in the limitless possibilities at the intersection of these fields. This revelation, coupled with my exposure to [specific technology or challenge], solidified my passion for computer science. Pursuing a Master's in CSE at [University] is a natural progression for me. The program's emphasis on [specific courses or specializations] aligns perfectly with my aspirations to [career goal in CSE]. I am eager to leverage my EEE background as a unique perspective in contributing to innovative solutions in the tech industry. This master's program is not just an academic pursuit but a strategic investment in bridging my experiences in EEE with my passion for the boundless potential of computer science. </p>


     
        <hr></hr>
        </div>
        </>,
      },
      {
        title: 'Goals',
        content: <>
        <div className='martop'></div>
          <p >
                    <strong>Career Goals : </strong>
                  </p>
                  <p><strong>Explanation: </strong>In this section, clearly outline your short-term and long-term career goals. Specify what you aim to achieve immediately after completing the course and paint a vivid picture of your aspirations for the next 10-15 years. Avoid mentioning a desire to stay in a foreign country for an extended period, as it can be perceived as a lack of commitment.</p>

                <p><strong>Mistakes that need to be taken care of: </strong></p>
                <p><strong>Vagueness: </strong> Clearly define your goals, providing details about the industry, role, or projects you aim to be involved in.</p>
                <p><strong>Contradictions:  </strong>Ensure that your stated goals align with the course you are applying for. Consistency is crucial for credibility.</p>
        </>,
      },
      {
        title: 'University',
        content: <>
      <p   style={{marginTop: '10px',}}><strong>Why this University: </strong>This section is your chance to show that you've done your homework on the university. Highlight specific features, resources, or faculty members that attract you. Explain how these elements align with your academic and career objectives. Convey a genuine interest in what the university offers beyond just a prestigious name.</p>
       
       <p>  <strong>Mistakes that need to be taken care of:  </strong></p>
       <p><strong>Generic Praise: </strong> Avoid using generic statements about the university's reputation. Instead, focus on unique features that resonate with your goals.</p>
       <p><strong>Lack of Personalization:</strong> Ensure your reasons for choosing the university go beyond general information available on their website. Personalize your response to demonstrate a deep understanding.  </p>  </>,
      },
      {
        title: 'Conclusion',
        content: <>
      <p   style={{marginTop: '10px',}}></p>

       <p><strong>Conclusion: </strong> Summarize the key points discussed in your Statement of Purpose. Reiterate your passion for the chosen field and emphasize how the course at the university is a crucial step toward achieving your goals. End on a strong note, leaving a lasting impression.</p>
       <p><strong>Mistakes that need to be taken care of:</strong></p>
       <p><strong>Introducing New Information:</strong> The conclusion is not the place for new information. Stick to summarizing what you've already discussed</p>
       <p><strong>Lack of Confidence: </strong>  Convey confidence in your goals and how the chosen course at the university is integral to your success.</p>
        </>,
      },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const contentStyle = {
    // lineHeight: '260px',
    // textAlign: 'center',
    // color: token.colorTextTertiary,
    // backgroundColor: token.colorFillAlter,
    // borderRadius: token.borderRadiusLG,
    // border: `1px dashed ${token.colorBorder}`,
    // marginTop: 16,
  };

  return (
    <>
      <Steps current={current} items={items} />
      <div style={contentStyle}>{steps[current].content}</div>
      <div
        style={{
          marginTop: 24,
        }}
      >
         {current > 0 && (
          <Button
            style={{
              margin: '0 8px',
            }}
            onClick={() => prev()}
          >
            Previous
          </Button>
        )}{current < steps.length - 1 && (
          <Button type="primary" onClick={() => next()}>
            Next
          </Button>
        )}
       
        {current === steps.length - 1 && (
          <Button type="primary" onClick={() => message.success(`Processing complete! Input: ${inputValue}`)}>
            Done
          </Button>
        )}
       
      </div>
    </>
  );
};

export default Sop2;
